import { createRoot } from 'react-dom/client';

import { CardTokenForm } from './components/CardTokenForm';

import type { TokenFormProps } from './@types';

let mounted = false;

export const isMounted = () => mounted;

export const mount = (elementId: string, props: TokenFormProps) => {
  const container = document.getElementById(elementId) as Element;
  if (container) {
    const root = createRoot(container);

    root.render(<CardTokenForm {...props} />);
    mounted = true;
  } else {
    mounted = false;
  }
};
